import React,{useState,useEffect} from 'react';
import {Button,Slider,Select,Row,Col} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Draggable from 'react-draggable';
import config from '../config.json';
import {useAxios} from "../../hooks/hooks";

function ArrowComponent(props) {
	const axios = useAxios();

	const CANVAS_WIDTH = 600;
	const CANVAS_HEIGHT = 400;
	const ICON_SIZE = 36;
	const [value,setValue] = useState(props.value || {});
	const [projectID,setProjectID] = useState(null);
	const [photoIndex,setPhotoIndex] = useState(null);
	const [arrowPosition,setArrowPosition] = useState(null);
	const [angle,setAngle] = useState(null);
	const [gallery,setGallery] = useState([]);

	const getGallery = async(id_project) => {
		if(id_project === null) return;
		try{
			const response = await axios.current.get("/photos/?page_size=100&filter[id_project]="+id_project);
			return response.data.rows;
		}catch(e){
			console.error(e);
			return null;
		}
	}

	const selectPhoto = (data) =>{
		setPhotoIndex(data);
	};

	const handleDrag = (e,data) => {
		var v = JSON.parse(JSON.stringify(value));
		v.arrow_x = 100*(data.x/(CANVAS_WIDTH-ICON_SIZE));
		v.arrow_y = 100*(data.y/(CANVAS_HEIGHT-ICON_SIZE));
		v.arrow_x = v.arrow_x > 100 ? 100 : v.arrow_x;
		v.arrow_y = v.arrow_y > 100 ? 100 : v.arrow_y;
		setValue(v);	
	};

	const updateGallery = () =>{
		Promise.all([
			getGallery(projectID)
		]).then((r)  => {
			const g = r[0];
			setGallery(g);
		});
	};

	useEffect(() => {
		if(props.view === true) return;
		if(undefined === value || value === null) return;
		var v = JSON.parse(JSON.stringify(value));
		if(photoIndex === null){
			v.photo_id = null;
			setValue(v);
			return;
		}
		var g = JSON.parse(JSON.stringify(gallery));
		var p = g[photoIndex];
		v.photo_id = p && p.url_photo ? p.url_photo : null;
		setValue(v);
	},[photoIndex]);

	useEffect(()=>{
		if(props.view === true) return;
		if(undefined === value || value === null) return;
		var v = JSON.parse(JSON.stringify(value));
		var g = JSON.parse(JSON.stringify(gallery));
		var index = null;
		var l = g.length;
		for(var i =0;i<l;i++){
			if(g[i].id_photo === v.photo_id){
				index = i;
				break;
			}
		}
		setPhotoIndex(index);
	},[gallery]);

	useEffect(() => {
		if(props.view === true) return;
		if(projectID === null) return;
		var v = JSON.parse(JSON.stringify(value));
		if(v === null) return;
		for(var i =0;i<props.foreignLists.id_project.length;i++){
			if(props.foreignLists.id_project[i].id === projectID){
				v.project_id = props.foreignLists.id_project[i].display_field_value;
				break;
			}
		}
		setValue(v);
		updateGallery();
	},[projectID]);

	useEffect(() => {
		var v = JSON.parse(JSON.stringify(value));
		v.arrow_angle = angle;	
		setValue(v);
	},[angle]);

	useEffect(() => {
		if(props.view === true) return;
		var v = JSON.parse(JSON.stringify(value));
		props.onChange({
      target:{
        id:props.id,
        value:v
      },
      currentTarget:{
        id:props.id,
        value:v
      }
		});
	},[value]);

	useEffect(() =>{
		if(props.view === true) return;
		var v = JSON.parse(JSON.stringify(props.value));
		v.arrow_x = Number(v.arrow_x || 0);
		v.arrow_y = Number(v.arrow_y || 0);
		v.arrow_angle = Number(v.arrow_angle || 0);
		if(undefined === v || v === null){
			v = {
				arrow_angle:0,
				arrow_x:0,
				arrow_y:0,
				photo_id:null,
				project_id:(props.currentValues.id_project || null)
			};
			setValue(v);
		}
		v.arrow_x = v.arrow_x > 100 ? 100 : v.arrow_x;
		v.arrow_y = v.arrow_y > 100 ? 100 : v.arrow_y;
		setArrowPosition({
			x:((v.arrow_x/100)*(CANVAS_WIDTH-ICON_SIZE)),
			y:((v.arrow_y/100)*(CANVAS_HEIGHT-ICON_SIZE))
		});
		setAngle(v.arrow_angle);
		if(isNaN(v.project_id) === false){
			return setProjectID(v.project_id);
		}
		setValue(v);
	},[props.view]);


	if(props.view === true)
	return (
		<>
			{props.caption === true && (
				<p>{props.value.project_id}</p>
			)}
			<div
				style={{
					display:"inline-block",
					width:CANVAS_WIDTH,
					height:CANVAS_HEIGHT,
					backgroundImage:"url("+(props.value.photo_id || config.fallback_image)+")",
					backgroundRepeat:"no-repeat",
					backgroundSize:"cover",
					position:"relative",
					backgroundPosition:"center center",
				}}
			>
				<FontAwesomeIcon 
					style={{
						display:(props.value.photo_id === null ? "none" : "block"),
						zIndex:24536,
						position:"absolute",
						color:props.color,
						marginLeft:((props.value.arrow_x/100)*(CANVAS_WIDTH-ICON_SIZE)),
						marginTop:((props.value.arrow_y/100)*(CANVAS_HEIGHT-ICON_SIZE)),
						transform:"rotate("+props.value.arrow_angle+"deg)"
					}}
					icon="arrow-down" 
					className="fa-fw fa-3x" 
				/>
			</div>
		</>
	);

	if(props.view !== true)
  return (
    <>
			<Row>
				<Col span={24}>
					<p>
						Select project and image, then drag and drop to set the position of 
						the arrow. Finally, use the slider to set the angle of the arrow.
					</p>
				</Col>
			</Row>
			<Row>
				<Col span={24}>
					<Select 
						value={projectID} 
						onChange={setProjectID} 
						disabled={props.currentDisabled && props.currentDisabled.indexOf("id_project") !== -1}
					>
						{props.foreignLists.id_project.map((option) => (
							<Select.Option key={option.id} value={option.id}>{option.display_field}</Select.Option>
						))}
					</Select>
				</Col>
			</Row>
			<Row>
				<Col span={24}>
					<div style={{width:"100%",overflowX:"scroll",whiteSpace:"nowrap"}}>
						<div style={{display:"inline-block"}}>
							<img 
								alt="None"
								height={100} 
								style={{margin:3,marginLeft:0,border:(photoIndex === null ? "#1890ff 2px solid" : "white 2px solid")}} 
								src={config.fallback_image} 
								onClick={e =>{selectPhoto(null)}}
							/>
						</div>
						{gallery.map((option,i) => (
							<div key={i} style={{display:"inline-block"}}>
								<img 
									alt={i}
									height={100} 
									style={{margin:3,marginLeft:0,border:(photoIndex === i ? "#1890ff 2px solid" : "white 2px solid")}} 
									src={option.url_photo} 
									onClick={e =>{selectPhoto(i)}}
								/>
							</div>
						))}
					</div>
				</Col>
			</Row>
			<Row>
				<Col span={24} style={{textAlign:"right",padding:16}}>
					<Button
						type="secondary"
						onClick={()=>updateGallery()}
					>
						<FontAwesomeIcon icon="sync"/>
						&nbsp;Refresh Gallery
					</Button>
				</Col>
			</Row>
			<Row>
				<Col span={24} style={{position:"relative"}}>
					{gallery[photoIndex] && gallery[photoIndex].url_photo && (
						<>
							<div
								style={{
									width:CANVAS_WIDTH,
									height:CANVAS_HEIGHT,
									backgroundImage:"url("+gallery[photoIndex].url_photo+")",
									backgroundRepeat:"no-repeat",
									backgroundSize:"cover",
									backgroundPosition:"center center"
								}}
							>
							<Draggable
								bounds={{
									top:0,
									left:0,
									right:(CANVAS_WIDTH-ICON_SIZE),
									bottom:(CANVAS_HEIGHT-ICON_SIZE),
								}}
								defaultPosition={arrowPosition}							
								onDrag={handleDrag}
							>
								<div 
									style={{
										margin:0,
										padding:0,
										width:36,
										height:36
									}}
								>
									<FontAwesomeIcon 
										style={{
											color:props.color,
											transform:"rotate("+angle+"deg)",
											margin:0,
											padding:0,
											marginLeft:-8,
											marginTop:-3,
										}}
										icon="arrow-down" 
										className="fa-fw fa-3x" 
									/>
								</div>
							</Draggable>
							</div>
						</>
					)}
				</Col>
			</Row>
			<Row>
				<Col span={24}>
					<Slider min={0} max={359} step={1} value={angle} onChange={setAngle}/>
				</Col>
			</Row>
    </>
  )
}

export default ArrowComponent;
